import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	graphButtonLabelNonFinal: {
		id: 'graph.graph-button-label-non-final',
		defaultMessage: 'Open the graph',
		description: 'Explains to the user what will happen when they click on the graph button',
	},
});
